/**
 * VueParentMixin
 * Provides methods for setting data attributes from objects.
 */
export default {
  methods: {
    /**
     * Map object properties to $data Vue component instance properties
     *
     * @param {Object} data
     * @param {Array} keysToMap
     */
    mapObjectPropertiesToVueData(data, keysToMap = []) {
      if (data) {
        const _this = this;
        Object.entries(data).forEach(([key, value]) => {
          if (this.isEmptyOrIncludes(key, keysToMap)) {
            _this[key] = value;
          }
        });
      }
    },

    /**
     * Maps a list of the object properties to $data Vue component instance properties
     *
     * @param {Object} data
     * @param {Array} keysToMap
     * @param {Array} childrenKeysToMap
     *
     * @see mapObjectPropertiesToVueData()
     */
    mapChildrenObjectPropertiesToVueData(data, keysToMap = [], childrenKeysToMap = []) {
      if (data) {
        const _this = this;
        Object.keys(data).forEach(key => {
          if (this.isEmptyOrIncludes(key, keysToMap)) {
            _this.mapObjectPropertiesToVueData(data[key], childrenKeysToMap);
          }
        });
      }
    },

    /**
     * Checks if a item (needle) is included in a list (haystack)
     * Always returns true when the list is empty
     *
     * @param needle
     * @param haystack
     * @returns {boolean}
     */
    isEmptyOrIncludes(needle, haystack) {
      return Array.isArray(haystack) && (haystack.length === 0 || haystack.includes(needle));
    }
  }
};
